/* eslint-disable no-console */
import axios from 'axios';
import { store } from '@/redux/store';

export const getToken = () => store.getState().userInfo?.token;
export const setRefreshToken = (token) => store.set('_tf', token);
export const getRefreshToken = () => store.get('_tf');
export const removeToken = () => store.remove('_t');
export const getOwnerId = () => store.getState().userInfo?.user?.ownerId
const defaultOptions = (isFile) => {
  const headers = {
    'Content-Type': isFile ? 'multipart/form-data' : 'application/json',
    Accept: isFile ? 'multipart/form-data' : 'application/json',
    'Accept-Language': 'en',
  };

  const token = getToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

const defaultInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_HOST,
});

export const apiFileUpload = async (url, params, options = {}) => {
  const formData = new FormData();
    formData.append(url, params,params.name);
 try {
  const results = await defaultInstance.post(`/files/profile/${url}?overwrite=true`, formData, {
    ...options,
  })
  return results.data;
 }
 catch {
  return error?.response?.data || error && error.data || error
 }
};

export const apiGet = async (url, options = {}) => {
  try {
    const results = await defaultInstance.get(url, {
      ...defaultOptions(false),
      ...options,
    });
    if (results?.data) {
      return results.data;
    }
    return false;
  } catch (error) {
    return error?.response?.data;
  }
};
export const apiGetPromise = async (url, options = {}) => new Promise((resolve, reject) => {
  defaultInstance.get(url, {
    ...defaultOptions(false),
    ...options,
  })
    .then((res) => resolve(res.data))
    .catch((error) => reject(error?.response?.data) || (error && error.data) || error);
});

export const apiPost = async (url, params, options = {}) => {
  try {
    const results = await defaultInstance.post(url, { ...params, tzo: (new Date().getTimezoneOffset()) }, {

      ...options,
    });
    if (results.data) return results.data;
    return results;
  } catch (error) {
    return error?.response?.data;
  }
};
export const apiPostPromise = async (url, params, options = {}) => new Promise((resolve, reject) => {
  defaultInstance.post(url, { ...params }, {
    ...options,
  })
    .then((response) => resolve(response.data))
    .catch((error) => reject((error && error.response && error.response.data) || (error && error.data) || error));
});
export const apiPutPromise = async (url, params, options = {}) => new Promise((resolve, reject) => {
  defaultInstance.put(url, { ...params }, {
    ...options,
  })
    .then((response) => resolve(response.data))
    .catch((error) => reject((error && error.response && error.response.data) || (error && error.data) || error));
});
export const apiPut = async (url, params, options = {}) => {
  try {
    const results = await defaultInstance.put(url, { ...params, tzo: (new Date().getTimezoneOffset()) }, {
      ...defaultOptions(false),
      ...options,
    });
    if (results.data) return results.data;
    return results;
  } catch (error) {
    return error.response?.data;
  }
};

export const apiLogin = async (username, password) => {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  params.append('grant_type', 'password');
  try {
    const response = await axios.post(
      process.env.NEXT_PUBLIC_AUTH_URL,
      params,
      {
        headers: {
          Authorization: `Basic ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`, // the token is a variable which holds the token
        },
      },
    );
    if (response.data) return response.data;
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export const apiDelete = async (url, options = {}) => {
  try {
    const results = await defaultInstance.delete(url, {
      ...defaultOptions(false),
      ...options,
    });
    if (results.data) return results.data;
    if (results.status >= 200 && results.status < 300) return true;

    return false;
  } catch (ex) {
    console.error(ex);
    return { error: ex };
  }
};

/*
defaultInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      removeToken();
      window.location = '/auth/login';
    }
  },
); */
